import { useEffect, useRef, type ReactNode } from 'react';

export const Dialog = ({
  open,
  onClose,
  kicker,
  title,
  children,
  wide,
}: {
  open: boolean;
  onClose: () => void;
  kicker?: string;
  title: string;
  children: ReactNode;
  wide?: boolean;
}) => {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    else if (!open && d.open) d.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="dialog"
      style={wide ? { width: 'min(760px, calc(100% - 2rem))' } : undefined}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
    >
      {open && (
        <>
          <div className="dialog-head">
            <div>
              {kicker && <p className="kick">{kicker}</p>}
              <h2 style={{ marginTop: kicker ? '.45rem' : 0 }}>{title}</h2>
            </div>
            <button type="button" className="icon-btn" aria-label="Fechar" onClick={onClose}>
              <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
              </svg>
            </button>
          </div>
          <div className="dialog-body">{children}</div>
        </>
      )}
    </dialog>
  );
};
